module.exports = __webpack_public_path__ + "static/media/pista_halwa.360d2d04.jpg";